const link = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M4.85 15.038a3.859 3.859 0 0 1-2.724-6.582l2.302-2.302 1.189 1.188-2.292 2.303a2.162 2.162 0 0 0 0 3.07 2.162 2.162 0 0 0 3.048 0L8.665 10.4l1.2 1.2-2.303 2.302a3.772 3.772 0 0 1-2.713 1.135m6.776-5.21L10.437 8.64l2.292-2.313c.406-.403.635-.951.637-1.523a2.162 2.162 0 0 0-3.685-1.535L7.389 5.57 6.19 4.38l2.303-2.302a3.923 3.923 0 0 1 5.404 0 3.859 3.859 0 0 1 0 5.404zm-5.069.822L5.368 9.46l4.637-4.647 1.2 1.19z"/></svg>',
};

export { link as default };
